import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const currencyRate = t.type({
  date: t.string,
  pair: t.string,
  rate: h.number().cast(),
  fetch_time: t.string,
  update_time: t.string,
});

export type CurrencyRate = t.TypeOf<typeof currencyRate>;
